/**
 * @license
 * Copyright 厦门乾元盛世科技有限公司 All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file.
 */


import { Component, Input, ElementRef, Renderer, ViewEncapsulation, HostBinding } from '@angular/core';
import classNames from 'classnames';
/**
 * 语义化的矢量图形。<br>
 * 我们为每个图标赋予了语义化的命名，命名规则如下:
 * - 实心和描线图标保持同名，用 `-o` 来区分，比如 `question-circle`（实心） 和 `question-circle-o`（描线）；
 * - 命名顺序：`[图标名]-[形状?]-[描线?]-[方向?]`。
 * > `?` 为可选。<br>
 * 完整的图标设计规范请访问 [图标规范](/docs/spec/icon)。<br>
 * 由于图标字体本质上还是文字，可以使用 `style` 和 `class` 设置图标的大小和颜色。
 */
export class Icon {
/**
 * 设置图标类型
 */
type: string;
/**
 * 是否有旋转动画
 */
spin = false;
/**
 * 样式前缀
 */
title: string;
/**
 * 用户CSS样式
 */
class: string;
/**
 * @param {?} renderer
 * @param {?} _elementRef
 */
constructor(private renderer: Renderer,
private _elementRef: ElementRef) {

    }
/**
 * 最终样式
 * @return {?}
 */
get classes(): string {
        const /** @type {?} */ classes = classNames({
            'anticon': true,
            'anticon-spin': !!this.spin || this.type === 'loading',
            [`anticon-${this.type}`]: true
        }, this.class);
        return classes;
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ant-icon',
    template: `<ng-content></ng-content>`,
    encapsulation: ViewEncapsulation.None
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer, },
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'type': [{ type: Input },],
'spin': [{ type: Input },],
'title': [{ type: Input },],
'class': [{ type: Input },],
'classes': [{ type: HostBinding, args: ['class', ] },],
};
}

function Icon_tsickle_Closure_declarations() {
/** @type {?} */
Icon.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Icon.ctorParameters;
/** @type {?} */
Icon.propDecorators;
/**
 * 设置图标类型
 * @type {?}
 */
Icon.prototype.type;
/**
 * 是否有旋转动画
 * @type {?}
 */
Icon.prototype.spin;
/**
 * 样式前缀
 * @type {?}
 */
Icon.prototype.title;
/**
 * 用户CSS样式
 * @type {?}
 */
Icon.prototype.class;
/** @type {?} */
Icon.prototype.renderer;
/** @type {?} */
Icon.prototype._elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
